import React from 'react';
import ButtonIcon from '@commoncomponents/frontend-components/dist/components/ButtonIcon';
import { IconArrowLeft, IconClose, } from '@commoncomponents/frontend-components/dist/components/Icons/Icons';
import { colors } from '@commoncomponents/frontend-components/dist/styled';
import styled from 'styled-components';
const ModalNavigation = ({ onModalClose, shouldBeBackButton, onBack, }) => {
    return (React.createElement(ModalNavigationWrapper, { shouldBeBackButton: shouldBeBackButton },
        shouldBeBackButton && (React.createElement(ButtonIcon, { className: "back-button", onClick: onBack },
            React.createElement(IconArrowLeft, { color: colors.rockyGrey }))),
        React.createElement(ButtonIcon, { className: "close-button", onClick: onModalClose },
            React.createElement(IconClose, { color: colors.rockyGrey }))));
};
const ModalNavigationWrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: ${({ shouldBeBackButton }) => shouldBeBackButton ? 'space-between' : 'flex-end'};
  .back-button {
    margin: 4px 0 0 12px;
  }
  .close-button {
    margin: 4px 12px 0 0;
  }
`;
export default ModalNavigation;
